import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { GetKongLocationAllResponseType } from 'features/Location/@types/location'
import { getKongLocationAll } from 'features/Location/services/location'
import {
  getInboundTaskList,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getInboundTaskDetail,
  postInboundTasksPartialGrn,
  getPoReasons,
  InboundTaskQueryParamsType,
  GetReasonsRequestParamsType,
} from 'features/PurchaseOrder/services/inboundTask'

export const SLICE_NAME = 'poInboundTask'

/* eslint-disable @typescript-eslint/naming-convention */
const getQueryParamsData = (
  queryParams: Partial<InboundTaskQueryParamsType>,
  selectedLocations: GetKongLocationAllResponseType['location'],
) => {
  const { page_index, page_size, invoice_number, purchase_order_number, search_product } =
    queryParams
  const locationIds = selectedLocations.map((item) => item.location_id)

  return {
    ...(invoice_number ? { invoice_number } : {}),
    ...(purchase_order_number ? { purchase_order_number } : {}),
    ...(search_product ? { search_product } : {}),
    ...(locationIds.length > 0 ? { location_ids: locationIds } : {}),
    page_index: page_index ?? 1,
    page_size: page_size ?? 20,
  } as Parameters<typeof getInboundTaskList>[0]
}
/* eslint-enable @typescript-eslint/naming-convention */

export const fetchGetLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetLocations`,
  async (name: undefined | string, { rejectWithValue }) => {
    try {
      const { data } = await getKongLocationAll({
        params: {
          name: name || '',
          active: true,
          page: 0,
          limit: 20,
        },
      })

      return data.data.location
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchInboundTaskList = createAsyncThunk(
  `${SLICE_NAME}/fetchInboundTaskList`,
  async (_: undefined, { getState, rejectWithValue }) => {
    try {
      const { queryParams, selectedLocations } = (getState() as StoreStateType).inboundTask
      const paramsToSend = getQueryParamsData(queryParams, selectedLocations)
      const { data } = await getInboundTaskList(paramsToSend)
      return data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchInboundTaskDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchInboundTaskDetail`,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await getInboundTaskDetail(id)
      return data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchReasons = createAsyncThunk(
  `${SLICE_NAME}/fetchReasons`,
  async (params: GetReasonsRequestParamsType, { rejectWithValue }) => {
    try {
      const { data } = await getPoReasons(params)
      return data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const submitInboundTaskPartialGrn = createAsyncThunk(
  `${SLICE_NAME}/submitInboundTaskPartialGrn`,
  async (data: Parameters<typeof postInboundTasksPartialGrn>[0], { dispatch, rejectWithValue }) => {
    try {
      const { data: responseData } = await postInboundTasksPartialGrn(data)
      dispatch(fetchInboundTaskList())
      return responseData
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
